/* eslint-disable react/destructuring-assignment */
import _ from 'lodash';
import classNames from 'classnames';
import React, { useState, useEffect, useContext } from 'react';
import { useDispatch } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { useLanguage } from 'hooks';
import { COLOR, ENG, SERVICE_OFFER_CATEGORY_NAME, CARTE_SERVICE_OFFERS } from 'config/constants';
import { HvModal } from 'components';
import { images } from 'assets/images';
import { ServiceOffer } from 'models';
import { ShootingContext } from 'contexts';

const useStyles = makeStyles({
  servicePriceRow: {
    marginTop: 10,
    marginBottom: 10,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  packageDescriptionRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
    paddingRight: 10,
  },
  packageDescription: {
    fontSize: 12,
  },
  serviceContent: {
    borderRadius: 8,
    padding: 8,
    border: '1px #bcbbc1 solid',
    marginBottom: 10,
    minWidth: 350,
  },
  selectedServiceContent: {
    borderRadius: 8,
    padding: 8,
    borderWidth: 1,
    borderColor: COLOR.GREY,
    backgroundColor: COLOR.WHITE,
  },
  tick: {
    right: 30,
  },
  serviceDivider: {
    width: 24,
    height: 24,
    borderRadius: 14,
    border: '2px #bcbbc1 solid',
  },
});

function RecommendationModal(props) {
  const styles = useStyles();
  const language = useLanguage();
  const intl = useIntl();
  const dispatch = useDispatch();
  const isEnglish = language === ENG;
  const { serviceOffers, selectedServices, availableServiceOffers } = props;
  const {
    shooting,
    recommendedServiceOffers,
    updateShootingFields,
    setShowRecommendationModal,
    setIgnoreRecommendation,
  } = useContext(ShootingContext);
  const onClose = () => {
    setShowRecommendationModal(false);
    setIgnoreRecommendation(true);
  };
  const onToggleServiceOffer = (so: ServiceOffer, isDisabled: boolean) => {
    return () => {
      if (isDisabled) return;
      const _serviceOffers = _.clone(shooting.service_offers);
      const index = _.findIndex(_serviceOffers, (m: ServiceOffer) => {
        return so?.serviceOffer?.id === m?.serviceOffer?.id;
      });
      const floorplanSelected = _serviceOffers.find((m: ServiceOffer) => {
        return m?.serviceOffer?.category?.display_name === SERVICE_OFFER_CATEGORY_NAME.FLOOR_PLAN;
      });
      const carteMeasureService = availableServiceOffers.find((m: ServiceOffer) => {
        return m?.serviceOffer?.id === CARTE_SERVICE_OFFERS.MEASURE;
      });
      if (index !== -1) {
        if (!(so.serviceOffer.id === CARTE_SERVICE_OFFERS.MEASURE && floorplanSelected)) {
          _serviceOffers.splice(index, 1);
        }
        const existingCarteMeasureIndex = _.findIndex(_serviceOffers, (m: ServiceOffer) => {
          return carteMeasureService?.serviceOffer?.id === m?.serviceOffer?.id;
        });
        if (
          so?.serviceOffer?.category?.display_name === SERVICE_OFFER_CATEGORY_NAME.FLOOR_PLAN &&
          existingCarteMeasureIndex !== -1
        ) {
          _serviceOffers.splice(existingCarteMeasureIndex, 1);
        }
      } else {
        _serviceOffers.push(so);
        const existingCarteMeasureIndex = _.findIndex(_serviceOffers, (m: ServiceOffer) => {
          return carteMeasureService?.serviceOffer?.id === m?.serviceOffer?.id;
        });
        if (
          so?.serviceOffer?.category?.display_name === SERVICE_OFFER_CATEGORY_NAME.FLOOR_PLAN &&
          carteMeasureService &&
          existingCarteMeasureIndex === -1
        ) {
          _serviceOffers.push(carteMeasureService);
        }
      }
      updateShootingFields({ service_offers: _serviceOffers }, true);
    };
  };
  const isServiceSelected = (so: ServiceOffer) => {
    return !!selectedServices.find((m: ServiceOffer) => {
      return m.serviceOffer.id === so.serviceOffer.id;
    });
  };

  const isServiceDisabled = (so: ServiceOffer) => {
    if (so.serviceOffer?.is_global) {
      return false;
    }

    const nonGlobalServiceOffers = selectedServices?.filter((m: ServiceOffer) => {
      return !m.serviceOffer.is_global;
    });

    const ngso = nonGlobalServiceOffers.find((m: ServiceOffer) => {
      return m.serviceOffer.id === so.serviceOffer.id;
    });
    if (ngso) return false;

    const userIds = _.flatten(
      nonGlobalServiceOffers.map((so: ServiceOffer) => {
        return so.serviceOffer.users;
      }),
    );

    const serviceOfferTechs = _.get(so.serviceOffer, 'users', []);

    for (let i = 0; i < serviceOfferTechs.length; i++) {
      const user = serviceOfferTechs[i];
      if (userIds.indexOf(user) !== -1) return false;
    }

    return !!_.intersection(userIds, so.serviceOffer?.users || []).length;
  };
  return (
    <HvModal
      title={intl.formatMessage({ id: 'promotion.recommendedServices' })}
      //   buttons={buttons}
      onClose={onClose}
    >
      {serviceOffers.map((s) => {
        const isSelected = isServiceSelected(s);
        const isDisabled = isServiceDisabled(s);
        return (
          <Box
            className={styles.serviceContent}
            key={s.serviceOffer.id}
            onClick={onToggleServiceOffer(s, isDisabled)}
          >
            {s.serviceOffer.example?.image_url ? (
              <img
                style={{ width: '100%', height: 250, objectFit: 'contain', marginBottom: 5 }}
                src={s.serviceOffer.example.image_url}
                alt='example'
              />
            ) : null}
            <Box className={styles.packageDescriptionRow}>
              <Typography>
                {isEnglish ? s.serviceOffer.display_name : s.serviceOffer.display_name_fr}
              </Typography>
            </Box>
            <Box key={s.serviceOffer.id} className={styles.servicePriceRow}>
              <Typography className={styles.packageDescription}>
                {`$ ${s.serviceOffer.price}`}
              </Typography>
              <Box className={styles.tick}>
                {isSelected ? (
                  <img src={images.tick} style={{ width: 30, height: 30 }} alt='checkbox' />
                ) : (
                  <Box className={styles.serviceDivider} />
                )}
              </Box>
            </Box>
          </Box>
        );
      })}
    </HvModal>
  );
}

export default RecommendationModal;
